<template>
  <div>
    <label class="file-input-label" for="file-input" @dragover.prevent @drop="handleDrop">
      {{ placeholder }}
    </label>
    <input id="file-input" class="file-input" type="file" multiple @change="handleFileUpload">
  </div>
</template>
<script>
export default {
  name: 'FileInput',
  props: {
    placeholder: {
      type: String,
      required: false,
      default : "Drop a file hear"
    }
  },
  methods: {
    handleDrop(event) {
      event.preventDefault();
      this.$emit("onChange", event.dataTransfer.files);
    },
    handleFileUpload(event) {
      this.$emit("onChange", event.target.files);
    }
  }
}

</script>
<style scoped>
/* 파일 업로드 인풋 */
.file-input-label {
  font-weight: normal;
  padding: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  border: 1px solid rgb(220, 220, 220);
}
.file-input-label:hover {
  cursor: pointer;
  border: 1px solid black;
}
.file-input-label + input {
  display: none;
}
</style>